var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_vm._v(" "+_vm._s(_vm.$t('errors.invalid_collegiate_number', { email: _vm.supportEmail }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }